const SOGNI_AUTH_URL = 'https://app.sogni.ai/authenticate/';

export function hasTurnstileSiteKey(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

export function buildSogniSignupUrl(redirectUrl, authUrl = SOGNI_AUTH_URL) {
  const url = new URL(authUrl);
  url.searchParams.set('redirect', String(redirectUrl));
  url.searchParams.set('authMode', 'cookies');
  url.searchParams.set('view', 'signup');
  return url.toString();
}
